import React from "react";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
const PainChart = (props) => {
  console.log("Painchart props ", props);
  let loadedImages = props.loadedImages ? props.loadedImages : {};
  if (Object.keys(loadedImages).length === 0) return null;
  let painData = props.painData ? props.painData : [];
  console.log("Pain Data ", painData);
  let painLevelIndex = {
    "Not Applicable": 4,
    "No Pain": 3,
    Mild: 2,
    Moderate: 1,
    Severe: 0,
  };
  painData = painData.map((data) => {
    if (data === "") {
      return painLevelIndex["Not Applicable"];
    }
    return painLevelIndex[data];
  });
  console.log("Pain data ", painData);
  //Temp change for FB
  let pointStyle = painData.map((data) => loadedImages[data]);

  const data = {
    labels: props.labels, // Dates on x-axis
    datasets: [
      {
        label: "Pain Level",
        data: [...painData],
        borderWidth: 0, // Remove connecting line
        pointStyle: [...pointStyle], // Custom images as points
        pointRadius: 15, // Control the size of the images
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    devicePixelRatio: window.devicePixelRatio || 1,
    scales: {
      x: {
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Pain Levels",
        },
        ticks: {
          callback: function (value) {
            const levels = [
              "Severe",
              "Moderate",
              "Mild",
              "No Pain",
              "Not Applicable",
            ];
            return levels[value] || value;
          },
          stepSize: 1,
          min: 0,
          max: 3,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const levels = [
              "Severe",
              "Moderate",
              "Mild",
              "No Pain",
              "Not Applicable",
            ];
            return `${levels[context.raw]} - ${context.dataset.label}`;
          },
        },
      },
    },
  };

  if (Object.keys(loadedImages).length === 0) {
    return <p>Loading...</p>;
  } else {
    return <Line data={data} options={options} height={288} />;
  }
};

export default PainChart;
